<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>휴직기간</v-list-item-title>
          <v-list-item-subtitle>
            {{ date }} / {{ period }}일</v-list-item-subtitle
          >
          <v-list-item-subtitle>
            복직예정일은 {{ reInDate }} 입니다</v-list-item-subtitle
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title>대상자명</v-list-item-title>
          <v-list-item-subtitle> {{ famNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>생년월일</v-list-item-title>
          <v-list-item-subtitle> {{ famInfo }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청가능일</v-list-item-title>
          <v-list-item-subtitle> {{ available }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기신청일수</v-list-item-title>
          <v-list-item-subtitle> {{ appDays }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>휴직사유</v-list-item-title>
          <v-list-item-subtitle> {{ refReason }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { getLeaAbsAppDetail } from '@/api/workStatus';
import { mapMutations } from 'vuex';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  data: () => ({
    date: '',
    famNm: '',
    famInfo: '',
    refReason: '',
    period: '',
    reInDate: '',
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    addDate(pInterval, pAddVal, pYyyymmdd, pDelimiter) {
      var yyyy;
      var mm;
      var dd;
      var cDate;
      var cYear, cMonth, cDay;

      if (pYyyymmdd == '') {
        return '';
      }

      if (pDelimiter != '') {
        pYyyymmdd = pYyyymmdd.replace(eval('/\\' + pDelimiter + '/g'), '');
      }

      yyyy = pYyyymmdd.substr(0, 4);
      mm = pYyyymmdd.substr(4, 2);
      dd = pYyyymmdd.substr(6, 2);

      if (pInterval == 'yyyy') {
        yyyy = yyyy * 1 + pAddVal * 1;
      } else if (pInterval == 'm') {
        mm = mm * 1 + pAddVal * 1;
      } else if (pInterval == 'd') {
        dd = dd * 1 + pAddVal * 1;
      }

      cDate = new Date(yyyy, mm - 1, dd); // 12월, 31일을 초과하는 입력값에 대해 자동으로 계산된 날짜가 만들어짐.
      cYear = cDate.getFullYear();
      cMonth = cDate.getMonth() + 1;
      cDay = cDate.getDate();

      cMonth = cMonth < 10 ? '0' + cMonth : cMonth;
      cDay = cDay < 10 ? '0' + cDay : cDay;

      //if (pDelimiter != "") {
      return cYear + pDelimiter + cMonth + pDelimiter + cDay;
      //} else {
      //	return cYear + cMonth + cDay;
      //}
    },
  },

  async created() {
    let response = await getLeaAbsAppDetail(this.appInfoParam);

    if (response.data.data != null) {
      this.date =
        response.data.data.refSdate + ' ~ ' + response.data.data.refEdate;
      this.famNm = response.data.data.famNm;
      this.famInfo = response.data.data.famInfo;
      this.refReason = response.data.data.refReason;

      const oldDate = new Date(response.data.data.refSdate);
      const newDate = new Date(response.data.data.refEdate);
      let diff = Math.abs(newDate.getTime() - oldDate.getTime());
      diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

      this.period = diff + 1;

      this.reInDate = this.addDate('d', 1, response.data.data.refEdate, '-');

      this.available = response.data.data.remainDaysBefore;
      this.appDays = response.data.data.usedDaysBefore;

    }

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: {},
};
</script>
